import './App.css';
import Header from './components/Header';
import Home from './components/Home';
import About from './components/About';
import Experience from './components/Experience';
import Project from './components/Project';
import Skill from './components/Skill';
import Education from './components/Education';
import Certification from './components/Certification';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <>
      <Header/>
      <Home/>
      <About/>
      <Experience/>
      <Project/>
      <Skill/>
      <Education/>
      <Certification/>
      <Services/>
      <Contact/>
      <Footer/>
    </>
  );
}

export default App;